var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.routeName))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  return _vm.edit()
                }
              }
            },
            [_vm._v("Edit Gift")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.gift
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("GiftId")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.userGiftId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Gift Code")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.gifteeUuid))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Expiry Date")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.trialEndDateCustomFmt))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("corporationId")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.corporationName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Welcome Message")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.welcomeMessage))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Redeem Button Label")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.button_label_01))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Gift Pacage Description ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.signupGiftDesc))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Panel Title ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.panelHeading1))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Panel Description ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.panelHeading2))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Default Landing Page ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.landingPage))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Skip Interest Page after Singup ")]),
                _vm._v(" "),
                _vm.gift.skipInterestPage.toString() === "1"
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.gift.skipInterestPage.toString() !== "1"
                  ? _c("td", [_vm._v("No")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Validate User after Singup ")]),
                _vm._v(" "),
                _vm.gift.preValidate.toString() === "1"
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.gift.preValidate.toString() !== "1"
                  ? _c("td", [_vm._v("No")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [
                  _vm._v("Show Trial Expiry Message on Profile Page ")
                ]),
                _vm._v(" "),
                _vm.gift.trialExpiryMsgFlag.toString() === "1"
                  ? _c("td", [_vm._v("Yes")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.gift.trialExpiryMsgFlag.toString() !== "1"
                  ? _c("td", [_vm._v("No")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Panel Bullet 1 ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.panelBullet1))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Panel Bullet 2 ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.panelBullet2))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Panel Bullet 3 ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.panelBullet3))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Panel Bullet 4 ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.panelBullet4))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Panel Bullet 5 ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.panelBullet5))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Panel Bullet 6 ")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.gift.panelBullet6))])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75397aea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75397aea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Gifts/GiftDetails.vue
// module id = IvRd
// module chunks = 0